import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m9 11-6 6v3h9l3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Highlighter";
const Highlighter = memo(themed(Icon));
export {
  Highlighter
};
//# sourceMappingURL=highlighter.js.map
